// extracted by mini-css-extract-plugin
export var standaloneTable = "_ik-0";
export var standaloneTableWithBodyFill = "_ik-1";
export var withExtraHeader = "_ik-2";